/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://d7g2xz3mdre7vk5h2ayo5d4q6i.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-illnkpxul5eddkwivwzx4bqsma",
    "aws_cloud_logic_custom": [
        {
            "name": "bwrDigiEndpoint",
            "endpoint": "https://216rcydcqg.execute-api.us-east-1.amazonaws.com/fcmidev",
            "region": "us-east-1"
        },
        {
            "name": "bwrEndpoint",
            "endpoint": "https://4yk0ulfdi8.execute-api.us-east-1.amazonaws.com/fcmidev",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:081436fe-86bc-48f8-893d-f7324cf204d7",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_LpwMyM0GB",
    "aws_user_pools_web_client_id": "1mnhso2rujs7m4ilrgel153n4b",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "FAMILY_NAME",
        "GIVEN_NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "bwr-dashboard-fcmidev",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://dzatevoh7g1bc.cloudfront.net"
};


export default awsmobile;
